//Panel de control
export const panelRoutes = {
  name: 'menu.panel_de_control',
  to: '/',
  exact: true,
  icon: 'poll',
  rol: ['SADM', 'ADMIN', 'USER'],
};

//Asuntos
export const asuntosRoutes = {
  name: 'menu.asuntos',
  to: '/cienytech/asuntos/list',
  exact: true,
  icon: 'copy',
  rol: ['SADM', 'ADMIN', 'USER'],
};

//Etiquetas
export const etiquetasRoutes = {
  name: 'menu.etiquetas',
  to: '/cienytech/etiquetas/list',
  exact: true,
  icon: 'copy',
  rol: ['SADM', 'ADMIN', 'USER'],
};

//Stock
export const stockRoutes = {
  name: 'menu.stock',
  to: '/',
  exact: true,
  icon: 'chart-pie',
  rol: ['SADM', 'ADMIN', 'USER'],
  children: [
    { to: '/cienytech/stock/almacenes/list', name: 'menu.stock.almacenes', exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/stock/productos/list', name: 'menu.stock.productos', exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/stock/reservas/list', name: 'menu.stock.reservas',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/stock/bajas/list', name: 'menu.stock.bajas',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
  ]
};

//Gestión
export const gestionRoutes = {
  name: 'menu.gestion',
  to: '/',
  exact: true,
  icon: 'code-branch',
  rol: ['SADM', 'ADMIN', 'USER'],
  children: [
    { to: '/cienytech/gestion/productos/list', name: 'menu.gestion.productos', exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    //{ to: '/cienytech/gestion/conceptos/list', name: 'menu.gestion.conceptos', exact: true, icon: ''},
    { to: '/cienytech/gestion/presupuestos/list', name: 'menu.gestion.presupuestos',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/gestion/albaranes/list', name: 'menu.gestion.albaranes',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/gestion/facturas/list', name: 'menu.gestion.facturas',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/gestion/pendientes/list', name: 'menu.gestion.pendiente',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
  ]
};

//Clientes
export const clientesRoutes = {
  name: 'menu.clientes',
  to: '/',
  exact: true,
  icon: 'envelope-open',
  rol: ['SADM', 'ADMIN', 'USER'],
  children: [
    { to: '/cienytech/clientes/clientes/list', name: 'menu.clientes.clientes', exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/clientes/contactos/list', name: 'menu.clientes.contactos',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/clientes/cuentas/list', name: 'menu.clientes.cuentas',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
    { to: '/cienytech/clientes/listas/list', name: 'menu.clientes.listas',  exact: true, icon: '', rol: ['SADM', 'ADMIN', 'USER']},
  ]
};

//Proveedores
export const proveedoresRoutes = {
  name: "menu.proveedores",
  to: "/",
  exact: true,
  icon: "cart-plus",
  rol: ["SADM", "ADMIN", "USER"],
  children: [
    {
      to: "/cienytech/proveedores/proveedores/list",
      name: "menu.proveedores.proveedores",
      exact: true,
      icon: "",
      rol: ["SADM", "ADMIN", "USER"]
    },
    {
      to: "/cienytech/proveedores/pedidos/list",
      name: "menu.proveedores.pedidos",
      exact: true,
      icon: "",
      rol: ["SADM", "ADMIN", "USER"]
    },
    {
      to: "/cienytech/proveedores/pendientes/list",
      name: "menu.proveedores.pendientes",
      exact: true,
      icon: "",
      rol: ["SADM", "ADMIN", "USER"]
    }
  ]
};

//Estadísticas
export const estadisticasRoutes = {
  name: "menu.estadisticas",
  to: "/",
  exact: true,
  icon: "chart-bar",
  rol: ["SADM", "ADMIN", "USER"],
  children: [
    {
      to: "/cienytech/estadisticas/general",
      name: "menu.estadisticas.general",
      exact: true,
      icon: "",
      rol: ["SADM", "ADMIN", "USER"]
    }
  ]
};

//Administracion
export const adminRoutes = {
  name: 'menu.administracion',
  to: '/',
  exact: true,
  icon: 'cogs',
  rol: ['SADM', 'ADMIN'],
  children: [
    { to: '/cienytech/administracion/usuarios/list', name: 'menu.administracion.usuarios', exact: true, icon: '', rol: ['SADM', 'ADMIN']},
    { to: '/cienytech/administracion/plantillas-email', name: 'menu.administracion.configurar_correo', exact: true, icon: '', rol: ['SADM', 'ADMIN']},
    { to: '/cienytech/administracion/direcciones/list', name: 'menu.administracion.configurar_direccion', exact: true, icon: '', rol: ['SADM', 'ADMIN']},
    { to: '/cienytech/administracion/copia-oculta', name: 'menu.administracion.configurar_copia_oculta', exact: true, icon: '', rol: ['SADM', 'ADMIN']},
    { to: '/cienytech/administracion/nuevo-anio-fiscal', name: 'menu.administracion.nuevo_anio_fiscal', exact: true, icon: '', rol: ['SADM', 'ADMIN']},
  ]
};

export default [
  panelRoutes,
  asuntosRoutes,  
  stockRoutes,
  gestionRoutes,
  clientesRoutes,
  proveedoresRoutes,
  etiquetasRoutes,
  estadisticasRoutes,
  adminRoutes
];
